import styled from "styled-components";

interface InputProps {
  type: string;
  placeholder: string;
  value: string;
  marginBottom?: string;
  onChange(value: any): void;
}

export function Textarea({ type, placeholder, marginBottom, value, onChange }: InputProps) {
  return (
    <Component
      type={type}
      placeholder={placeholder}
      marginBottom={marginBottom}
      value={value}
      onChange={(e) => onChange(e.target.value as any)}
    />
  )
}

const Component = styled.textarea<InputProps>`
  width: 100%;
  height: 190px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.gray.light };
  border: ${({ theme }) => `2px solid ${theme.colors.gray.dark}` };
  font-size: 17px;
  padding: 0 16px;
  color: ${({ theme }) => theme.colors.gray.darker };
  margin-bottom: ${({ marginBottom }) => marginBottom || 0 };

  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
`;